import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function LandingPageLayoutMobile({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'problema', label: 'Il problema' },
    { id: 'soluzioni', label: 'Soluzioni' },
    { id: 'testimonianze', label: 'Testimonianze' },
    { id: 'prezzi', label: 'Prezzi' },
    { id: 'contatti', label: 'Contatti' },
    { id: 'accedi', label: 'Accedi' },
    { id: 'registrati', label: 'Registrati' },
  ];

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const scrollToSection = (id) => {
    setMobileOpen(false); // chiudi drawer
    if (id === 'accedi') {
      navigate('/login');
    }else if (id === 'registrati') {
                          navigate('/register');
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation">
      <List>
        {sections.map((sec) => (
          <ListItemButton key={sec.id} onClick={() => scrollToSection(sec.id)}>
            {sec.id === 'accediiii' ? (
              <Tooltip title="Accedi">
                <IconButton sx={{ color: '#2742F5' }} aria-label="Accedi">
                  <Person />
                </IconButton>
              </Tooltip>
            ) : (
              <ListItemText primary={sec.label} />
            )}
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return (
    <Box>
      <AppBar position="fixed" color="primary" sx={{ bgcolor: '#A8E6CF', color: '#A8E6CF' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <IconButton edge="start" onClick={handleDrawerToggle} aria-label="Apri menu">
            <MenuIcon />
          </IconButton>
          <Typography sx={{ color: '#2742F5' }} variant="h6" noWrap>
            DeskStudio
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: 250 } }}
      >
        {drawer}
      </Drawer>
      <Box sx={{ mt: 8 }}>{children}</Box>
    </Box>
  );
}
